module.exports = __webpack_public_path__ + "static/media/khawalid.d7990cba.webp";